import { updateApiClientConfig } from '@bbr/api-client';
import { mount, StartClient } from '@solidjs/start/client';
import { ErrorBoundary } from 'solid-js';
import { getConfigValue } from './modules/config.ts';

updateApiClientConfig({ baseUrl: getConfigValue('API_BASE') });

mount(() => {
	return (
		<ErrorBoundary fallback={(error) => <div>{error}</div>}>
			<StartClient />
		</ErrorBoundary>
	);
}, document.getElementById('app')!);
